export default ({ app }) => {
  if (process.server) return

  const USERFLOW_SCRIPT_URL = 'https://js.userflow.com/userflow.js'
  const USERFLOW_TOKEN = 'ct_irry3vu7xnbjpbgbzdik25743q'

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${src}"]`)
      if (existing) return resolve()

      const script = document.createElement('script')
      script.src = src
      script.async = true
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })

  loadScript(USERFLOW_SCRIPT_URL).then(() => {
    if (typeof userflow === 'undefined') {
      console.warn('Userflow failed to load')
      return
    }
    /* global userflow */

    userflow.init(USERFLOW_TOKEN)

    const interval = setInterval(() => {
      const auth = app.$auth
      const user = auth?.user

      if (
        auth?.loggedIn &&
        user &&
        typeof userflow.identify === 'function' &&
        !window.__userflowIdentified
      ) {
        const data = {
          name: user.name,
          email: user.email,
          signed_up_at: user.practiceLocation.createdAt
        }
        userflow.identify(user.id, data)

        const closeBtn = document.createElement('button')
        closeBtn.innerHTML = '&times;'
        closeBtn.style.position = 'fixed'
        closeBtn.style.bottom = '45px'
        closeBtn.style.left = '12px'
        closeBtn.style.width = '24px'
        closeBtn.style.height = '24px'
        closeBtn.style.borderRadius = '50%'
        closeBtn.style.background = '#fff'
        closeBtn.style.border = '1px solid #ccc'
        closeBtn.style.color = '#333'
        closeBtn.style.fontSize = '16px'
        closeBtn.style.lineHeight = '24px'
        closeBtn.style.display = 'flex'
        closeBtn.style.alignItems = 'center'
        closeBtn.style.justifyContent = 'center'
        closeBtn.style.cursor = 'pointer'
        closeBtn.style.zIndex = '1234511'
        closeBtn.title = 'Close'
        closeBtn.style.background = '#fff'
        closeBtn.style.border = '1px solid #2da433'
        closeBtn.style.color = '#2da433'
        closeBtn.addEventListener('click', () => {
          userflow.setResourceCenterLauncherHidden(true)
          userflow.closeResourceCenter()
          closeBtn.remove()
        });
        document.getElementById('userflow-ui').appendChild(closeBtn)

        window.__userflowIdentified = true
        clearInterval(interval)
      }
    }, 1000)
  }).catch((err) => {
    console.error('Failed to load Userflow script', err)
  })
}
